import { render, staticRenderFns } from "./CoolingCapacity.vue?vue&type=template&id=36d538ae"
import script from "./CoolingCapacity.vue?vue&type=script&lang=js"
export * from "./CoolingCapacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports